import { render, staticRenderFns } from "./UserRatings.vue?vue&type=template&id=7fdfc750&scoped=true"
import script from "./UserRatings.vue?vue&type=script&lang=js"
export * from "./UserRatings.vue?vue&type=script&lang=js"
import style0 from "./UserRatings.vue?vue&type=style&index=0&id=7fdfc750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdfc750",
  null
  
)

export default component.exports